import api from './api'

/**
 * Stock Ticker Service
 * Loads all tickers once; filtering is done client-side.
 */
class StockTickerService {
  /**
   * Fetch all active tickers from the server (call once on page load).
   * @returns {Promise<Array<{symbol: string, name: string, exchange: string}>>}
   */
  async getAll() {
    const response = await api.get('/api/v1/stock-tickers/all')
    return response.data?.data || response.data || []
  }

  /**
   * Filter a pre-loaded ticker list by query string (client-side).
   * Priority: exact symbol match > symbol prefix > name substring.
   * @param {Array} allTickers - Full ticker list from getAll()
   * @param {string} query - Search input
   * @param {number} limit - Max results (default 20)
   */
  filter(allTickers, query, limit = 20) {
    if (!query || query.trim().length === 0) return []
    const q = query.trim().toUpperCase()
    const exact = []
    const prefix = []
    const nameMatch = []
    for (const t of allTickers) {
      const sym = t.symbol.toUpperCase()
      const name = t.name.toUpperCase()
      if (sym === q) exact.push(t)
      else if (sym.startsWith(q)) prefix.push(t)
      else if (name.includes(q)) nameMatch.push(t)
    }
    return [...exact, ...prefix, ...nameMatch].slice(0, limit)
  }
}

export default new StockTickerService()
